
import { ProductTemplate } from '@/assets/interface/Product';
import { ImageInfo } from '@luxtag/papybase';
import { concat, find, findIndex } from 'lodash';

export const MUTATE_TEMPLATE = 'MUTATE_TEMPLATE';
export const ADD_TEMPLATE = 'ADD_TEMPLATE';
export const RENAME_TEMPLATE = 'RENAME_TEMPLATE';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const ADD_PHOTO = 'ADD_PHOTO';
export const MUTATE_PHOTOS = 'MUTATE_PHOTOS';
export const DELETE_PHOTO = 'DELETE_PHOTO';

interface ITemplateStore {
    templates: ProductTemplate[];
    photos: ImageInfo[];
}

// initial state
const templateState: ITemplateStore = {
    templates: [],
    photos: [],
};

// getters
const getters = {
    getTemplates: (state: ITemplateStore) => state.templates,
    getTemplate: (state: ITemplateStore) => (productTemplate: string) => find(
        state.templates, (template: ProductTemplate) => template.productTemplate === productTemplate,
    ),
    isProductTemplateExist: (state: ITemplateStore) => (productTemplate: string) => findIndex(
        state.templates, (template: ProductTemplate) => template.productTemplate === productTemplate,
    ) !== -1,
    getPhotos: (state: ITemplateStore) => state.photos,
};

// mutations
const mutations = {
    [MUTATE_TEMPLATE](state: ITemplateStore, payload: ProductTemplate[]) {
        state.templates = payload;
    },
    [ADD_TEMPLATE](state: ITemplateStore, payload: ProductTemplate) {
        const theIndex = findIndex(state.templates, template => template.productTemplate === payload.productTemplate);
        if (theIndex === -1) {
            // add
            state.templates.push(payload);
        } else {
            // edit
            state.templates.splice(theIndex, 1, payload);
        }
    },
    [RENAME_TEMPLATE](state: ITemplateStore, payload: any) {
        const theIndex = findIndex(state.templates, template => template.productTemplate === payload.oldName);
        if (theIndex !== -1) {
            // add
            state.templates[theIndex].productTemplate = payload.newName;
        }
    },
    [DELETE_TEMPLATE](state: ITemplateStore, payload: number) {
        // the payload is an index
        const theIndex = findIndex(state.templates, template => template.id === payload);
        state.templates.splice(theIndex, 1);
    },
    [MUTATE_PHOTOS](state: ITemplateStore, payload: ImageInfo[]) {
        state.photos = payload;
    },
    [ADD_PHOTO](state: ITemplateStore, payload: ImageInfo[] | ImageInfo) {
        state.photos = concat(state.photos, payload);
    },
    [DELETE_PHOTO](state: ITemplateStore, payload: string) {
        // the payload is an index
        const theIndex = findIndex(state.photos, photo => photo.hash === payload);
        state.photos.splice(theIndex, 1);
    },
};

// actions
const actions = {
};

export default {
    state: templateState,
    getters,
    actions,
    mutations,
};
